import type { Brand } from '@whiz-cart/node-shared/models/brand/brand';

export default function getProvidedArgs(brand: Brand | undefined) {
    return {
        cartBrand: brand?.cartBrand ?? 'Whiz-Cart',
        cartBrandShort: brand?.cartBrandShort ?? 'Whiz-Cart',
        storeBrand: brand?.storeBrand ?? 'Supermarket',
        loyaltyCard: brand?.loyaltyCard ?? 'Loyalty Card',
    };
}
